import type { FixedLineItem } from '@vy/types';
import React from 'react';
import { DynamicInvoicePromotionLineItem } from '../DynamicInvoicePromotionLineItem';
import { DynamicInvoiceViewSection } from '../DynamicInvoiceViewSection';

type PromotionLineItemsSectionProps = {
  promotionLineItems: FixedLineItem[];
};

export const PromotionLineItemsSection: React.FC<PromotionLineItemsSectionProps> = ({
  promotionLineItems,
}) => {
  return (
    <DynamicInvoiceViewSection title="Discount">
      {promotionLineItems.map((lineItem, index) => (
        <DynamicInvoicePromotionLineItem
          key={lineItem.id}
          promotionLineItem={lineItem}
          showDivider={promotionLineItems.length !== 1 && index !== promotionLineItems.length - 1}
        />
      ))}
    </DynamicInvoiceViewSection>
  );
};
